export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT'
